/* eslint-disable react-hooks/exhaustive-deps */
import "./admin-table.css";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { BsEye, BsTrash3Fill } from "react-icons/bs";
import { useEffect } from "react";
import {
  deleteDoctor,
  getAllDoctors,
} from "../../redux/apiCalls/doctorsApiCalls";
import { toast } from "react-toastify";

const DoctorsTable = () => {
  const dispatch = useDispatch();
  const { doctors } = useSelector((state) => state.doctor);

  useEffect(() => {
    dispatch(getAllDoctors());
  }, []);

  // Delete doctor Handler
  const deleteDoctorHandler = (doctorId) => {
    swal({
      title: "هل تريد الحذف فعلا ؟",
      text: "لن تستطيع استعادة بيانات الطبيب ثانية",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((isOk) => {
      if (isOk) {
        dispatch(deleteDoctor(doctorId));
        toast.success("تم حذف بيانات الطبيب")
      }
    });
  };

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <h1 className="table-title">الاطباء</h1>
        <table className="table">
          <thead>
            <tr>
              <th>م</th>
              <th>طبيب</th>
              <th>المؤهل</th>
              <th>-----</th>
            </tr>
          </thead>
          <tbody>
            {doctors?.map((item, index) => (
              <tr key={item._id}>
                <td>{index + 1}</td>
                <td>
                  <div className="table-image">
                    <img
                      src={item?.image?.url}
                      alt=""
                      className="table-user-image"
                    />
                    <span className="table-username">{item?.name}</span>
                  </div>
                </td>
                <td>
                  <b className="doctor-title">{item?.title}</b>
                </td>
                <td>
                  <div className="table-button-group">
                    <button>
                      <Link to={`/doctors/details/${item._id}`}>
                        <BsEye />
                      </Link>
                    </button>
                    <button onClick={() => deleteDoctorHandler(item?._id)}>
                      <BsTrash3Fill />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DoctorsTable;
